import { css } from 'styled-components';
import { AssignmentStatusEnum } from 'api/model';
import { tableCellClassName } from 'components/Table/utils';

export const newDataFromRideClassName = 'new-data-from-ride';
export const assigneeIsUnavailableOnDate = 'assignee-is-unavailable-on-date';
export const adminHasUnreadCommentsClassName = 'admin-has-unread-comments';
export const furtherTransportAssignmentClassName = 'further-transport-assignment';

export const assignmentStatusClassNames = {
  Created: 'assignment-created',
  Assigned: 'assignment-assigned',
  Active: 'assignment-active',
  OnHold: 'assignment-on-hold',
  Complete: 'assignment-completed',
  Removed: 'assignment-removed',
  Approved: 'assignment-approved',
  CasePending: 'case-pending',
};

export const getAssignmentStatusClassName = (
  assignmentStatusID: AssignmentStatusEnum
) => {
  switch (assignmentStatusID) {
    case AssignmentStatusEnum.Created:
      return assignmentStatusClassNames.Created;

    case AssignmentStatusEnum.Assigned:
      return assignmentStatusClassNames.Assigned;

    case AssignmentStatusEnum.OnHold:
      return assignmentStatusClassNames.OnHold;

    case AssignmentStatusEnum.Accepted:
    case AssignmentStatusEnum.Started:
    case AssignmentStatusEnum.Arrived:
    case AssignmentStatusEnum.TestComplete:
    case AssignmentStatusEnum.Returning:
      return assignmentStatusClassNames.Active;

    case AssignmentStatusEnum.Complete:
      return assignmentStatusClassNames.Complete;

    case AssignmentStatusEnum.Approved:
      return assignmentStatusClassNames.Approved;

    case AssignmentStatusEnum.Canceled:
    case AssignmentStatusEnum.Aborted:
      return assignmentStatusClassNames.Removed;

    default:
      return '';
  }
};

/**
 * Status-based row colouring shared between the `/sök` assignments table and the
 * `/efterkontroll` auto-approval table, so the two stay visually identical.
 */
export const assignmentStatusRowColorsCss = css`
  .${assignmentStatusClassNames.Created},
    .${assignmentStatusClassNames.Assigned},
    .${assignmentStatusClassNames.Complete},
    .${assignmentStatusClassNames.CasePending} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  }

  .${assignmentStatusClassNames.Created} {
    background-color: rgb(249 237 204);
    font-weight: 500;
  }
  .${assignmentStatusClassNames.Assigned} {
    background: rgb(255 252 224);
  }
  .${assignmentStatusClassNames.Active} {
  }
  .${assignmentStatusClassNames.OnHold} {
    background-color: rgb(240 220 240);
  }
  .${assignmentStatusClassNames.Complete} {
    background-color: rgb(228 243 222);
    font-weight: 500;
  }
  .${assignmentStatusClassNames.Approved} {
    //background-color: #d7ffc1;
  }
  .${assignmentStatusClassNames.Removed} .${tableCellClassName} {
    color: #c01111;
    text-decoration: line-through;
  }
  .${assignmentStatusClassNames.CasePending} {
    background-color: #e7f4ff;
  }

  .${newDataFromRideClassName},
    .${adminHasUnreadCommentsClassName},
    .${assigneeIsUnavailableOnDate} {
    font-weight: bold;
  }

  .${furtherTransportAssignmentClassName} {
    background-color: ${({ theme }) => theme.colors.background.secondary};
  }
`;
